//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import Empty from '../_around_facilities/_empty'
import PoiList from '../_around_facilities/_poi_list'
import consult from '../_around_facilities/consult'

import { FormatDistance } from '../_around_facilities/distance'

export const TYPES = {
    school: '学校',
    hospital: '医院',
    shopping: '购物',
    bus: '公交',
    food: '美食',
}
const TABS = Object.keys(TYPES).map(key => {
    return {
        key,
        name: TYPES[key]
    }
})
export default {
    mixins: [
        consult,
    ],
    data() {
        return {
            items: [],
            tabs: TABS,
            category: 'school',
            categories: []
        }
    },
    props: {
        building_id: Number,
        staticmap_url: String
    },
    components: {
        Empty,
        PoiList
    },
    mounted() {
        this.initCategory()
    },
    methods: {
        async getData() {
            const params = {
                page: 1,
                per: 3,
                category: this.category
            }
            let data = await Service.getAcround(this.building_id, params)
            const { categories, items } = data
            this.categories = categories
            items.forEach((item) => {
                item.address = ''
                item.distance = FormatDistance(item.distance)
            })
            this.items = items
        },
        async initCategory() {
            const params = {
                page: 1,
                per: 3,
                category: this.category
            }
            const data = await Service.getAcround(this.building_id, params)
            const { categories } = data
            for (let i = 0; i < this.tabs.length; i++) {
                const tab = this.tabs[i]
                for(let j = 0; j < categories.length; j++) {
                    const _category = categories[j]
                    if (_category.name === tab.key && _category.count) {
                        this.category = tab.key
                        this.getData()
                        return
                    }
                }
            }
            this.getData()
        },
        changeType (e) {
            const { key, name } = e.currentTarget.dataset
            this.category = key
            this.$sendCtmEvtLog(`楼盘详情页-周边配套模块-点击tab-${name}`)
            this.getData()
        },
        goMore() {
            this.$sendCtmEvtLog(`楼盘详情-功能模块-周边配套点击`,{building_id: this.building_id})
            wx.navigateTo({
                url: `/building/around_facilities/map/main?id=${this.building_id}&category=${this.category}`
            })
        }
    },
}
